import React from 'react'
import { Container, Alert, Button } from 'react-bootstrap'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Unhandled render error', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container className='py-5'>
          <Alert variant='danger'>
            <Alert.Heading>Something went wrong</Alert.Heading>
            <p>
              An unexpected error occurred. Please reload the page. If the
              problem continues, contact support.
            </p>
            <Button variant='outline-danger' onClick={() => window.location.reload()}>
              Reload page
            </Button>
          </Alert>
        </Container>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
